import React from 'react';
import { usePagination } from './usePagination';
import { PaginationProps } from './types';
import styles from './Pagination.module.css';

/**
 * ページネーションコンポーネント
 * 現在のページ、総ページ数、ページ変更時のコールバックを受け取り、
 * ページネーションUIを表示する
 */
const Pagination: React.FC<PaginationProps> = (props) => {
  const { pages, handleEllipsisClick } = usePagination(props);

  return (
    <div className={styles['pagination-wrapper']} data-testid="pagination">
      {pages.map((item, index) => {
        if (item === 'left-ellipsis') {
          return (
            <button
              key={`left-ellipsis-${index}`}
              className={`${styles['pagination-button']} ${styles['pagination-button--ellipsis']}`}
              onClick={() => handleEllipsisClick('left')}
              data-testid="pagination__left-ellipsis"
            >
              …
            </button>
          );
        }
        if (item === 'right-ellipsis') {
          return (
            <button
              key={`right-ellipsis-${index}`}
              className={`${styles['pagination-button']} ${styles['pagination-button--ellipsis']}`}
              onClick={() => handleEllipsisClick('right')}
              data-testid="pagination__right-ellipsis"
            >
              …
            </button>
          );
        }
        return (
          <button
            key={`page-${item}`}
            className={`${styles['pagination-button']} ${
              item === props.currentPage ? styles['pagination-button--active'] : ''
            }`}
            onClick={() => props.onPageChange(item)}
            data-testid={item === props.currentPage ? 'pagination__active-page' : `pagination__page-${item}`}
          >
            {item}
          </button>
        );
      })}
    </div>
  );
};

export default Pagination; 